<template>
    <div class="table">
        <!-- 查询条件 -->
        <div style="margin-bottom:10px;">
            <el-select v-model="form.deptId" placeholder="请选择学校" style="width:160px;" @change="common.page=1;getData()">
                <el-option
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            &nbsp;
            <el-input v-model="form.coinName" placeholder="校币名称" style="width:160px;" clearable></el-input>
            &nbsp;
            <el-select v-model="form.evaluateType" placeholder="五育类型" style="width:130px;" clearable>
                <el-option v-for="item in evaluateTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            &nbsp;
            <el-button type="primary" icon="search" @click="common.page=1;getData()">查询</el-button>
            <el-button type="primary" @click="toAdd()">新增</el-button>
        </div>

        <el-table
            :data="data"
            style="width:100%;margin-bottom:20px;"
            row-key="id"
            height="550"
            v-loading="loading"
            element-loading-text="数据正在加载中..."
            element-loading-background="rgba(255,255,255,0.7)"
            border>
            <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
            <el-table-column prop="coinName" label="校币名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="coinDenomination" label="面额(元)" width="90"></el-table-column>
            <el-table-column prop="correspondingPoints" label="对应积分" width="90"></el-table-column>
            <el-table-column prop="evaluateType" label="五育类型" width="130">
                <template slot-scope="scope">
                    {{ formatEvaluateType(scope.row.evaluateType) }}
                </template>
            </el-table-column>
                <el-table-column label="校币图片" width="90">
                <template slot-scope="scope">
                    <img v-if="scope.row.coinImageUrl" :src="scope.row.coinImageUrl" style="width:40px;height:40px;object-fit:contain;" />
                    <span v-else style="color:#999;">无</span>
                </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="排序号" width="80"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="toUpdate(scope.row)" type="text" size="small" style="color:#387EE8;">修改</el-button>
                    <el-button @click.native.prevent="del(scope.row)" type="text" size="small" style="color:red;">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="common.page"
                :page-size="common.pageSize"
                :page-sizes="common.allSizes"
                layout="total,sizes,prev,pager,next,jumper"
                :total="common.total">
            </el-pagination>
        </div>

        <!-- 新增弹框 -->
        <div v-if="addVisible">
            <coinAdd ref="coinAdd" @refresh="getData"></coinAdd>
        </div>
        <!-- 修改弹框 -->
        <div v-if="updateVisible">
            <coinUpdate ref="coinUpdate" @refresh="getData"></coinUpdate>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import coinAdd from './Add.vue';
    import coinUpdate from './Update.vue';

    export default {
        name: "CoinList",
        components: { coinAdd, coinUpdate },
        data() {
            return {
                loading: false,
                addVisible: false,
                updateVisible: false,
                common: {
                    total: 0,
                    pageSize: 20,
                    page: 1,
                    allSizes: [20, 50, 100]
                },
                form: {
                    deptId: "",
                    coinName: "",
                    evaluateType: ""
                },
                depts: [],
                data: [],
                evaluateTypeOptions: [
                    { value: '1', label: '德育' },
                    { value: '2', label: '智育' },
                    { value: '3', label: '体育' },
                    { value: '4', label: '美育' },
                    { value: '5', label: '劳育' }
                ]
            }
        },
        created() {
            this.getDeptData();
        },
        methods: {
            indexMethod(index) {
                return (this.common.page - 1) * this.common.pageSize + (index + 1);
            },
            getDeptData() {
                let url = this.listDeptUrl;
                let data = { parentId: "0" };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.depts = res.data.list;
                        if (this.depts.length > 0) {
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => { console.log(err); });
            },
            getData() {
                this.loading = true;
                let url = this.schoolCoinListUrl;
                let data = {
                    isPage: 1,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    coinName: this.form.coinName,
                    evaluateType: this.form.evaluateType
                };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.data = res.data.list;
                        this.common.total = res.data.total;
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                    this.loading = false;
                }, (err) => {
                    console.log(err);
                    this.loading = false;
                });
            },
            toAdd() {
                this.addVisible = true;
                this.$nextTick(() => {
                    this.$refs['coinAdd'].init(this.form.deptId);
                });
            },
            toUpdate(row) {
                this.updateVisible = true;
                this.$nextTick(() => {
                    this.$refs['coinUpdate'].init(row);
                });
            },
            del(row) {
                this.$commonFn.showConfirm(() => {
                    this.loading = true;
                    let url = this.schoolCoinDelUrl;
                    this.apiPost(url, { id: row.id }).then((res) => {
                        this.loading = false;
                        if (res.status == 200) {
                            this.$commonFn.showTip(res.message, 1);
                            this.getData();
                        } else {
                            this.$commonFn.showTip(res.message, 3);
                        }
                    }, (err) => {
                        console.log(err);
                        this.loading = false;
                    });
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            formatEvaluateType(val) {
                if (!val) return '';
                const map = { '1': '德育', '2': '智育', '3': '体育', '4': '美育', '5': '劳育' };
                return map[val] || val;
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/schoolCoin/coinList/list.vue